const ErrorCode = {
  AUTHORIZATION_FAILURE: 'login_invalid',
};

export default ErrorCode;
